export default __webpack_public_path__ + "static/media/game-console.29274846.png";